module.exports = __webpack_public_path__ + "img/daijianluomu.prt.9568cbcc.jpg";